// Lightweight runtime holder for the fetched brand payload, so any component
// (e.g. AppHeader, deep on the /app route) can read the agent/house brand
// without threading props through every parent.
let _brand = null;
const _subs = [];
export function setBrandPayload(b) { _brand = b; _subs.forEach(fn => { try { fn(b); } catch (_e) {} }); }
export function getBrandPayload() { return _brand; }
export function subscribeBrand(fn) { _subs.push(fn); return () => { const i = _subs.indexOf(fn); if (i >= 0) _subs.splice(i, 1); }; }
